export default async function syncDeerFlowSessionPolling(session, deps) {
    const {
        handleDeerFlowHistory,
        formatHistoryRecord,
        changeSessionMapItem,
        changeOriginMsgMapRef,
        originMsgMapRef,
        currentSessionMapIdRef,
        deerFlowHook,
        skillListRef
    } = deps || {};

    try {
        const res = await handleDeerFlowHistory({ thread_id: session.session_id });
        if (res && res.code === 200) {
            const messages = res.data.messages;
            const taskStatusMap = res.data?.task_status_map || {};
            const currentTaskId = res.data?.current_task_id;

            // 检查任务的具体状态
            const hasLoadingMessage = messages && messages.some((msg) => msg.status === 'loading');
            const currentTaskStatus = currentTaskId ? taskStatusMap[currentTaskId] : null;
            const lastMessage = messages && messages.length > 0 ? messages[messages.length - 1] : null;
            const lastMessageNotUser = lastMessage && lastMessage.role !== 'user';

            // 判断是否需要继续轮询
            const taskCompleted = currentTaskStatus === 0;
            const taskStopped = currentTaskStatus === -1;
            const noLoadingMessages = !hasLoadingMessage;

            // 只有任务明确完成或停止时才更新canPause状态
            const shouldUpdateCanPause = (taskCompleted || taskStopped) && noLoadingMessages && lastMessageNotUser;

            if (shouldUpdateCanPause) {
                // 任务已完成或停止，更新状态但不启动轮询
                let { showMsg, allMsg } = await formatHistoryRecord(messages, session);

                // 根据任务状态设置不同的会话状态
                let sessionStatus = null;
                if (currentTaskStatus === -1) {
                    sessionStatus = -1; // 任务停止
                } else if (currentTaskStatus === 0) {
                    sessionStatus = null; // 任务完成
                }

                const sessionState = {
                    messages: showMsg,
                    loading: false,
                    answering: false
                };

                changeOriginMsgMapRef({
                    [session?.session_id]: {
                        ...originMsgRefSafe(originMsgMapRef, session?.session_id),
                        messages: allMsg,
                        status: sessionStatus
                    }
                });

                changeSessionMapItem(session?.session_id, sessionState, allMsg);

                // 更新本地 grt_history_sessions 的 canPause/isClickable
                try {
                    const historySessions = JSON.parse(localStorage.getItem('grt_history_sessions') || '[]');
                    const sessionIndex = historySessions.findIndex((item) =>
                        typeof item === 'object' ? item.sessionId === session.session_id : item === session.session_id
                    );
                    if (sessionIndex !== -1 && typeof historySessions[sessionIndex] === 'object') {
                        historySessions[sessionIndex].canPause = false;
                        historySessions[sessionIndex].isClickable = false;
                        localStorage.setItem('grt_history_sessions', JSON.stringify(historySessions));
                    }
                } catch (error) {
                    console.error('🔥 一次性检查时更新本地存储失败:', error);
                }
            } else if (currentTaskStatus === 2) {
                // 如果任务状态为2（继续），确保 canPause 保持 true
                try {
                    const historySessions = JSON.parse(localStorage.getItem('grt_history_sessions') || '[]');
                    const sessionIndex = historySessions.findIndex((item) =>
                        typeof item === 'object' ? item.sessionId === session.session_id : item === session.session_id
                    );
                    if (sessionIndex !== -1 && typeof historySessions[sessionIndex] === 'object') {
                        if (historySessions[sessionIndex].canPause !== true) {
                            historySessions[sessionIndex].canPause = true;
                            localStorage.setItem('grt_history_sessions', JSON.stringify(historySessions));
                        }
                    }
                } catch (error) {
                    console.error('🔥 恢复canPause状态失败:', error);
                }

                // 对于继续中的任务，更新状态并启动轮询
                let { showMsg, allMsg } = await formatHistoryRecord(messages, session);

                const sessionState = {
                    messages: showMsg,
                    loading: true,
                    answering: false
                };

                changeOriginMsgMapRef({
                    [session?.session_id]: {
                        ...originMsgRefSafe(originMsgMapRef, session?.session_id),
                        messages: allMsg,
                        status: 0
                    }
                });

                changeSessionMapItem(session?.session_id, sessionState, allMsg);

                deerFlowHook.startHistoryPolling(session, {
                    formatHistoryRecord,
                    changeSessionMapItem,
                    changeOriginMsgMapRef,
                    originMsgMapRef,
                    currentSessionMapIdRef,
                    skillListRef
                });
            } else {
                // 任务还在进行中，需要启动轮询（默认处理）
                let { showMsg, allMsg } = await formatHistoryRecord(messages, session);

                const sessionState = {
                    messages: showMsg,
                    loading: true,
                    answering: false
                };

                changeOriginMsgMapRef({
                    [session?.session_id]: {
                        ...originMsgRefSafe(originMsgMapRef, session?.session_id),
                        messages: allMsg,
                        status: 0
                    }
                });

                changeSessionMapItem(session?.session_id, sessionState, allMsg);

                deerFlowHook.startHistoryPolling(session, {
                    formatHistoryRecord,
                    changeSessionMapItem,
                    changeOriginMsgMapRef,
                    originMsgMapRef,
                    currentSessionMapIdRef,
                    skillListRef
                });
            }
        }
    } catch (error) {
        console.error('🔥 DeerFlow一次性状态检查失败:', error);
    }
}

function originMsgRefSafe(originMsgMapRef, sessionId) {
    try {
        return originMsgMapRef && originMsgMapRef.current && originMsgMapRef.current[sessionId]
            ? originMsgMapRef.current[sessionId]
            : {};
    } catch (e) {
        return {};
    }
}


